import React from 'react';
import * as motion from 'motion/react-m';
import { Box } from '@osmosis/react-ui/components/Box';
import { expand } from '../../../../../styles/animation';
import { QuizExplanationObject } from '../../../../../types/quiz';
import { S3_BUCKET_URL } from '@osmosis/constants';

/**
 * Explanation message for multiple-choice options.
 */
export const ExplanationMessage = ({
  explanation,
}: {
  explanation: string | QuizExplanationObject;
}) => {
  const explanationHtml =
    typeof explanation === 'string' ? explanation : explanation.s;

  return (
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    <motion.div {...(expand() as any)}>
      <Box
        width="100%"
        textAlign="left"
        mt="10px"
        sx={{ wordWrap: 'break-word' }}
      >
        <div
          style={{ color: 'gray60', display: 'inline-block' }}
          dangerouslySetInnerHTML={{
            __html: explanationHtml
              .replace(/<node/g, '<img')
              .replace(/img:/g, S3_BUCKET_URL),
          }}
        />
      </Box>
    </motion.div>
  );
};
